import React from 'react';
import { Inline } from '@balance-web/inline';
import { Tooltip } from '@balance-web/tooltip';

import { createTestId } from './utils';
import type { UtilityActions } from './types';
import { ItemWrapper } from './ItemWrapper';

type UtilityIconsRendererProps = {
  utilityActions?: UtilityActions;
};

export const UtilityActionsRenderer = ({
  utilityActions,
}: UtilityIconsRendererProps) => {
  if (!utilityActions?.length) {
    return null;
  }

  return (
    <Inline gap="xsmall">
      {utilityActions.map(({ Icon, key, onClick, testid, tooltipContent }) => {
        const data = {
          testid: !!testid ? createTestId('utility-action', testid) : undefined,
        };

        if (!!tooltipContent) {
          return (
            <Tooltip key={key} content={tooltipContent}>
              <ItemWrapper as="button" onClick={onClick} data={data}>
                <Icon size="medium" color="muted" />
              </ItemWrapper>
            </Tooltip>
          );
        }

        return (
          <ItemWrapper key={key} as="button" onClick={onClick} data={data}>
            <Icon size="medium" color="muted" />
          </ItemWrapper>
        );
      })}
    </Inline>
  );
};
